<script>
export default {
  name: "DoneIcon"
}
</script>

<template>
  <svg width="15" height="15" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.90652 2.49426L4.63695 7.37377L2.80713 5.54396" stroke="#fff" stroke-width="0.838666"
          stroke-miterlimit="10" stroke-linecap="square"/>
  </svg>
</template>

<style scoped>

</style>
